// Load Bootstrap JS
import $ from "expose-loader?exposes=$,jQuery!jquery";
import lightbox from "expose-loader?exposes=lightbox!lightbox2";
lightbox.option({
  albumLabel: 'Bild %1 von %2',
  alwaysShowNavOnTouchDevices: false,
  fadeDuration: 200,
  fitImagesInViewport: true,
  imageFadeDuration: 200,
  positionFromTop: 50,
  resizeDuration: 200,
  showImageNumberLabel: true,
  wrapAround: true,
  disableScrolling: false,
});

import './nouislider';

import 'bootstrap';

// Load Fontawesome
import './fontawesome';

// Load Js
import './navbar';
import './scrolllistener';
import './propertylist';
import './propertymapbox';

// Mask-Elements
import './pageheader';

// Load Styles
import '../Scss/main.scss';


